import React from "react";
import ReactDOM from "react-dom";

import "./static/scss/app.scss"
import App from "./app";

ReactDOM.render(
    <App/>,
    document.getElementById('root')
);
